import styled, { css } from 'styled-components/macro';
import { COLORS, TRANSITIONS } from '../../../styles/Theme';
import { Input } from '../FormComponents/index.jsx';
import { Button } from '../Buttons/styles';
import { less, lessH } from '../../../styles';

export const LoginContainer = styled.div`
    position: relative;
    width: 568px;
    height: 496px;
    background: linear-gradient(107.41deg, #F8F8FB 49.07%, #FFFCF3 109.41%);
    border-radius: 16px;

    ${less.tabletL(css`
        width: 508px;
        height: 442px;
    `)}

    ${lessH.tablet(css`
        width: 508px;
        height: 442px;
    `)}
`;

export const LoginInnerContainer = styled.div`
    padding: 32px 64px;
    width: 100%;
    height: 100%;

    ${less.tabletL(css`
        padding: 18px 44px;
    `)}

    ${lessH.tablet(css`
        padding: 18px 44px;
    `)}
`;

export const LoginTitle = css`
    color: ${COLORS.BLUE};
    font-weight: bold;
    text-align: center;
    margin-bottom: 28px;

    ${less.tabletL(css`
        margin-bottom: 0px;
        font-size: 26px;
        line-height: 32px;
    `)}

    ${lessH.tablet(css`
        margin-bottom: 0px;
        font-size: 26px;
        line-height: 32px;
    `)}
`;

export const LoginFormContainer = styled.form`
    position: relative;
`;

export const RegistrationLink = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 16px;
    margin-top: 16px;
    font-size: 13px;
    font-weight: bold;
    color: ${COLORS.BLUE};
    cursor: pointer;
    display: flex;
    width: fit-content;
    margin: 18px auto;
    
    div {
        display: flex;
    }

    svg {
        margin-right: 4px;
    }

    a {
        font-size: 13px;
        font-weight: 600;
    }
`;

export const AccountTitle = css`
    font-weight: bold;
    color: ${COLORS.BLUE};
    margin-right: 4px;
`;

export const StyledInput = styled(Input)`
    input {
        transition: ${TRANSITIONS.FAST};
        color: ${COLORS.BLACK_LIGHT}
    }

    ${(props) => props.lastEl && css`
        margin-bottom: 0px;
    `}

    ${(props) => props.isError && css`
      color: ${COLORS.RED_LIGHT};

      input {
        color: ${COLORS.RED_LIGHT};
      }

      svg path {
        stroke: ${COLORS.RED_LIGHT} !important;
      }

      label {
        color: ${COLORS.RED_LIGHT};
      }
    `}
`;

export const ForgotPassTitle = css`
    text-align: center;
    font-weight: 600;
    margin-top: 16px; 
`;

export const ButtonSubmit = styled(Button)`
    margin-top: 30px;

    ${less.tabletL(css`
        margin-top: 22px;
    `)}

    ${lessH.tablet(css`
        margin-top: 22px;
    `)}
`;

export const ErrorMessage = styled.div`
    color: ${COLORS.RED_LIGHT};
    position: absolute;
    bottom: 47px;
    font-weight: 600;
    left: 0;

    div {
        font-weight: bold;
    }
`;
